var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_280)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_77_280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.504028 0.0995941H59.312V53.9612H0.504028V0.0995941Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55139 29.102C7.4705 29.102 6.49338 26.7466 8.04953 25.4829L28.4062 8.91011C28.8201 8.57345 29.3544 8.38751 29.908 8.38751C30.4616 8.38751 30.996 8.57345 31.4099 8.91011L51.7665 25.4829C53.3227 26.7466 52.3433 29.102 50.2646 29.102H48.0028V43.6032C48.0028 44.1526 47.7645 44.6795 47.3403 45.068C46.9161 45.4565 46.3408 45.6748 45.7409 45.6748H14.0751C13.4752 45.6748 12.8999 45.4565 12.4757 45.068C12.0515 44.6795 11.8132 44.1526 11.8132 43.6032V29.102H9.55139ZM23.1225 41.5316V31.1736C23.1225 30.6242 23.3608 30.0972 23.785 29.7087C24.2091 29.3202 24.7844 29.102 25.3843 29.102H34.4317C35.0316 29.102 35.6069 29.3202 36.0311 29.7087C36.4553 30.0972 36.6936 30.6242 36.6936 31.1736V41.5316H43.4791V27.0304C43.479 26.6618 43.5863 26.2999 43.7899 25.982C43.9935 25.6641 44.2859 25.4017 44.6372 25.2219L29.908 13.2273L15.1789 25.2219C15.5301 25.4017 15.8226 25.6641 16.0261 25.982C16.2297 26.2999 16.337 26.6618 16.3369 27.0304V41.5316H23.1225ZM27.6462 41.5316V33.2452H32.1699V41.5316H27.6462Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_77_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.908 53.9612C46.1474 53.9612 59.312 41.9038 59.312 27.0304C59.312 12.1569 46.1474 0.0995941 29.908 0.0995941C13.6687 0.0995941 0.504028 12.1569 0.504028 27.0304C0.504028 41.9038 13.6687 53.9612 29.908 53.9612Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.808,
    height: 53.8616,
    fill: "white",
    transform: "translate(0.504028 0.0995941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.b60e95b1f3faf750b046b3af29f4a76a.svg";
export { ForwardRef as ReactComponent };